import http from './http';

export default {
    getAll(query = '') {
        return http.get(`/routeofadministration${query}`);
    },
    getAllBySubstanceId(substanceId) {
        return this.getAll(`?substanceID=${substanceId}`);
    },
    create(data) {
        return http.post('/routeofadministration', data);
    },
    update(route) {
        return http.put(`/routeofadministration/${route.info.id}`, route);
    },
    delete(id) {
        return http.delete(`/routeofadministration/${id}`);
    },
    unusedImportCodes() {
        return http.get('/routeofadministration/unusedImportCodes');
    },
};
